import { render, staticRenderFns } from "./Etapa.vue?vue&type=template&id=1fe244c8"
import script from "./Etapa.vue?vue&type=script&lang=js"
export * from "./Etapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports